<div class="main-content">
  <div class="bg-city-blue visitor-card-title">
    <span class="font-size-h1">
      {{ "visitor_card_lbl_visitor_card" | translate }}
    </span>
  </div>

  <div class="user-info-container" fxLayout="row">
    <div fxLayoutAlign="center start" fxFlex="1 2 auto">
      @if (profileImgLink) {
      <img
        src="{{ profileImgLink }}"
        (error)="profileImgLink = ''"
        class="profile-image"
      />
      } @if (!profileImgLink) {
      <mat-icon class="profile-image-empty-icon">account_circle</mat-icon>
      }
    </div>
    <div fxLayout="column" fxLayoutAlign="center" fxFlex="2 2 auto">
      <div class="color-city-neutral font-size-small-text-bold">
        {{ "visitor_card_lbl_visitor_name" | translate }}
      </div>
      <div class="color-dark-blue font-size-body-text display-label-detail">
        {{ fullName }}
      </div>
      <div class="color-city-neutral font-size-small-text-bold">
        {{ "visitor_card_lbl_visitor_phone" | translate }}
      </div>
      <div class="color-dark-blue font-size-body-text display-label-detail">
        {{ phoneNumber }}
      </div>
      <div class="color-city-neutral font-size-small-text-bold">
        {{ "visitor_card_lbl_visitor_company" | translate }}
      </div>
      <div class="color-dark-blue font-size-body-text display-label-detail">
        {{ companyName }}
      </div>
    </div>
  </div>

  <div class="divider"></div>
  <div class="divider"></div>
  <mat-divider></mat-divider>
  <div class="divider"></div>

  <div fxLayout="column" class="sign-in-datetime-container">
    @if (signInDateTime) {
    <div class="signed-in-datetime" fxLayoutAlign="center start">
      <span class="header-lbl-text-font font-size-h1 color-city-blue"
        >{{ signInDateTime | date : "MMMM d" }},
        {{ signInDateTime | date : "hh:mm a" }}</span
      >
    </div>
    }
    <div fxLayout="row">
      <div fxLayoutAlign="center center" fxFlex="1 2 40%">
        <span class="signedIn-text font-size-body-text" id="lbl_signedin">
          {{ "visitor_card_lbl_signedin" | translate }}
        </span>
      </div>
      <div fxLayoutAlign="center center" fxFlex="1 2 60%">
        <div class="color-dark-blue font-size-body-text display-label-detail">
          {{ currentSite?.name }}
        </div>
      </div>
    </div>
  </div>

  <div class="divider"></div>
  <div class="divider"></div>
  <mat-divider></mat-divider>
  <div class="divider"></div>

  @if (profileRapidGlobalRequired && objCompliance) {
  <span class="compliance-box">
    <div class="divider"></div>
    <div fxLayout="row">
      <div class="color-city-blue font-size-body-text-bold">
        {{ "visitor_card_lbl_compliancecheck" | translate }}
      </div>
    </div>
    <div class="divider"></div>
    <div class="compliance-induction-rows">
      <div class="induction-button-display induction-card-container">
        <div fxLayout="row" fxFlex="100">
          <div fxLayoutAlign="start center" class="induction-button-img">
            <img class="site-image" src="/assets/RapidGlobalLogo.png" />
          </div>
          <div
            fxLayout="column"
            class="induction-button-msg"
            fxLayoutAlign="center center"
          >
            @if (objCompliance.statusId) {
            <div class="induction-status">
              {{ getCompliantStatus(objCompliance.statusId) }}
            </div>
            }
          </div>
          <div class="induction-button-icon induction-button-icon-actions" fxLayoutAlign="center center">
            @if (objCompliance.statusId === enumCityComplianceStatus.COMPLIANT
            || objCompliance.companyName == defaultCityFMCompanyName ||
            objCompliance.companyName == defaultCityFMAsiaCompanyName) {
            <mat-icon class="color-city-green">task_alt</mat-icon>
            } @if (objCompliance.statusId === 
            enumCityComplianceStatus.NOTCOMPLIANT) {
            <mat-icon class="color-city-red">error</mat-icon>
            } @if (objCompliance.statusId ===
            enumCityComplianceStatus.NOTAPPLICABLE) {
            <div
              class="induction-status-indicator"
              fxLayout="column"
              fxLayoutAlign="center center"
            >
              <span class="na-icon induction-action-label">{{ "visitor_card_lbl_error_message_icon" | translate }}</span>
            </div>
            }
          </div>
        </div>
      </div>
      <br/>
      <app-induction-card-status></app-induction-card-status>
    </div>


    <div class="divider"></div>
    <mat-divider></mat-divider>
  </span>
  } @if (siteVisitReasons && siteVisitReasons.length > 0) {
  <span class="reason-for-visit-box">
    <div class="divider"></div>
    <div fxLayout="row">
      <div class="color-city-blue font-size-body-text-bold">
        {{ "visitor_card_lbl_reason_for_visit" | translate }}
      </div>
    </div>
    @if (!isJobReason()) {
    <div>
      <div class="divider"></div>
      @for (reason of siteVisitReasons; track reason) {
      <div fxLayout="row" fxLayoutAlign="center">
        <div fxLayout="column" fxFlex="95">
          @if (reason.calloutReferenceNumber != '') {
          <li class="color-city-blue">{{ reason.calloutReferenceNumber }}</li>
          }
        </div>
      </div>
      }
    </div>
    } @if (isJobReason()) {
    <div>
      @if (allocatedJobs.length > 0) {
      <div>
        <div class="divider"></div>
        <ul class="color-city-blue">
          @for (job of allocatedJobs; track job) {
          <li>
            <span>#{{ job.referenceNumber }}</span
            ><br />
            <span>{{ job.faultServiceName }}</span
            ><br />
            @if (job.eta != null) {
            <div>
              @if (isReactiveJob(job)) {
              <span>ETA: {{ job.eta | date : "dd-MM-yyyy hh:mm a" }}</span>
              } @if (isPPMJob(job)) {
              <span>Due On: {{ job.eta | date : "dd-MM-yyyy" }}</span>
              }
            </div>
            }
            <div class="divider"></div>
          </li>
          }
        </ul>
      </div>
      }
    </div>
    }
    <div class="divider"></div>
    <mat-divider></mat-divider>
  </span>
  } @if (permitQnA) {
  <span>
    <div class="divider"></div>
    <div fxLayout="row">
      <div class="color-city-blue font-size-body-text-bold">
        {{ "visitor_card_lbl_work_permit" | translate }}
      </div>
    </div>
    <div fxLayout="row">
      @if (permitQnA.answer && permitQnA.answer == this.permit[1]) {
      <span>{{ "visitor_card_lbl_required_workpermit" | translate }}</span>
      } @if (permitQnA.answer != this.permit[1]) {
      <span>{{ "visitor_card_lbl_notrequired_workpermit" | translate }}</span>
      }
    </div>
    <div class="divider"></div>
    <mat-divider></mat-divider>
  </span>
  }

  <div class="close-button">
    <button
      mat-raised-button
      id="visitor_card_close"
      data-testid="visitor_card_close"
      (click)="closeCard()"
    >
      {{ "visitor_card_lbl_close_card" | translate }}
    </button>
  </div>
</div>
